import CreativeType from '@/Enums/Creatives/CreativeType.enum';
import type { ICreativeFormData } from '@/Interfaces/Creatives/Creative.interface';
import { IDV360TicketsCreativeFormData } from '@/Interfaces/DV360Tickets/Creative.interface';
export const defaultFormData: ICreativeFormData = {
  name: '',
  advertiser: null,
  clickUrl: '',
  format: CreativeType.VIDEO,
  file: null,
  tagContent: null,
  duration: '',
  pixels: [],
  creativeSize: null,
  companionAssetImage: null,
  companionAssetFileUrl: '',
  companionAssetThumbnail: '',
  alternativeId: '',
};

export const dv360DefaultFormData: IDV360TicketsCreativeFormData = {
  name: '',
  advertiserId: null,
  type: CreativeType.VIDEO,
  file: null,
  videoUrl: null,
  clickUrl: '',
};
